import {types} from "../../types/types";

const INITIAL_STATE = {
    goal: {
        goalData: null,
        goalError: null,
        goalLoading: false,
        goalBotConfig: null,
        loadedGoalBot: false,
        isRegistered: null, // 🔹 null: desconocido, true: sí existe, false: no existe
    },
};


export const ampleadReducer = (state = INITIAL_STATE, action) => {
    const {type, payload} = action;

    switch (type) {
        case types.ampleadGoalData:
            return {
                ...state,
                goal: {
                    ...state.goal,
                    goalData: payload,
                    goalError: null
                }
            };
        case types.goalBotConfig:
            return {
                ...state,
                goal: {
                    ...state.goal,
                    goalBotConfig: payload,
                    loadedGoalBot: true,

                }
            };

        case types.ampleadGoalError:
            return {
                ...state,
                goal: {
                    ...state.goal,
                    goalError: payload
                }
            };

        case types.ampleadGoalLoading:
            return {
                ...state,
                goal: {
                    ...state.goal,
                    goalLoading: payload
                }
            };
        case types.goalBotRegisterStatus:
            return {
                ...state,
                goal: {
                    ...state.goal,
                    isRegistered: payload,
                    loadedGoalBot: true,
                },
            };

        case types.ampleadGoalReset:
            return INITIAL_STATE;
        default:
            return state;
    }
};
